import React from "react"
import { FlexBox } from "./FlexBox"

interface ITestHiddenDataProps {
  id: string
  data?: string | number
}

export const TestHiddenData = ({ id, data }: ITestHiddenDataProps) => {
  if (!IS_NOT_PROD) {
    return null
  }
  return (
    <FlexBox
      id={id}
      sx={{
        "maxWidth": 0,
        "maxHeight": 0,
        "p": 0,
        "m": 0,
        "overflow": "hidden",
        "& > *": { visibility: "hidden", display: "none", maxWidth: 0, maxHeight: 0 }
      }}>
      {data}
    </FlexBox>
  )
}
